import React, { useEffect, useState } from "react";
import axios from "axios";

import Navbar from "../../Components/Navbar";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Inventaire = (props) => {
  const token = localStorage.getItem("JWT");

  const [loaded, setLoaded] = useState(""); // gestion du useEffect
  const [stuffOwned, setStuffOwned] = useState([]); // changement du rendu suivant le boutton
  const [statut, setStatut] = useState(1); // etat de la page suivant le button

  const [selectCarte, setSelectCarte] = useState(""); // attribution des elements selectionnés par le joueur
  const [selectAvatar, setSelectAvatar] = useState("");
  const [selectCadre, setSelectCadre] = useState("");

  function getOneUser() {
    //recup de l'utilisateur

    const userId = localStorage.getItem("userId");

    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}api/auth/userInventory/${userId}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        setSelectCarte(res.data.selectCarte);
        setSelectAvatar(res.data.selectAvatar);
        setSelectCadre(res.data.selectCadre);

        switch (statut) {
          case 1:
            setStuffOwned(res.data.cartes);
            break;
          case 2:
            setStuffOwned(res.data.avatars);
            break;
          case 3:
            setStuffOwned(res.data.cadres);
            break;
          default:
            break;
        }
      })
      .catch((err) => {});
  }

  function filtres(e) {
    // filtre menu

    let focusCarteButton = document.getElementById("images");
    let focusAvatarButton = document.getElementById("avatars");
    let focusCadreButton = document.getElementById("cadres");

    focusCarteButton.style.border = "none";
    focusAvatarButton.style.border = "none";
    focusCadreButton.style.border = "none";

    switch (e.target.id) {
      case "images":
        setLoaded("images");
        setStatut(1);
        e.target.style.border = "3px solid #ffd204";
        break;

      case "avatars":
        setLoaded("avatars");
        setStatut(2);
        e.target.style.border = "3px solid #ffd204";
        break;

      case "cadres":
        setLoaded("cadres");
        setStatut(3);
        e.target.style.border = "3px solid #ffd204";
        break;

      default:
        break;
    }
  }

  function changeDisplay(e) {
    // modification de l'objet a afficher sur la carte membre

    let thingsId = e.target.firstChild;
    thingsId = thingsId.firstChild.id;
    localStorage.setItem("inventoryThingsId", thingsId);

    let focusCard = e.target.firstChild;
    let focusAll = document.querySelectorAll(
      ".ongletInventaire__ItemContainer__displayItem__cardContainer__card"
    );

    focusAll.forEach((element) => {
      element.classList.remove("inventoryOnClick");
    });

    focusCard.classList.add("inventoryOnClick");
  }

  function applyChoice(e) {
    const userId = localStorage.getItem("userId");
    const focusCarteId = localStorage.getItem("inventoryThingsId");

    if (focusCarteId) {
      switch (statut) {
        case 1:
          axios({
            method: "put",
            url: `${process.env.REACT_APP_API_URL}api/auth/modifySelectedCarte/${userId}`,
            headers: {
              Authorization: `Bearer ${token}`,
            },
            data: {
              focusCarteId,
            },
          })
            .then((res) => {
              toast.success("Carte Membre mise a jour!");
            })
            .catch((err) => {
              toast.error(
                "Erreur lors de la mise a jour de votre carte membre!"
              );
            });

          break;

        case 2:
          axios({
            method: "put",
            url: `${process.env.REACT_APP_API_URL}api/auth/modifySelectedAvatar/${userId}`,
            headers: {
              Authorization: `Bearer ${token}`,
            },
            data: {
              focusAvatarId: focusCarteId,
            },
          })
            .then((res) => {
              toast.success("Carte Membre mise a jour!");
            })
            .catch((err) => {});
          break;
        case 3:
          axios({
            method: "put",
            url: `${process.env.REACT_APP_API_URL}api/auth/modifySelectedCadre/${userId}`,
            headers: {
              Authorization: `Bearer ${token}`,
            },
            data: {
              focusCadreId: focusCarteId,
            },
          })
            .then((res) => {
              toast.success("Carte Membre mise a jour!");
            })
            .catch((err) => {});

          break;
        default:
          break;
      }
    }
  }

  useEffect(() => {
    // gestion du style des cartes suivant l'etat de la page

    switch (statut) {
      case 1:
        let focus1 = document.querySelectorAll(".inventaireCartes");

        focus1.forEach((element) => {
          element.style.objectFit = "cover";

          let focusAll = document.querySelectorAll(
            ".ongletInventaire__ItemContainer__displayItem__cardContainer__card"
          );

          focusAll.forEach((element) => {
            if (element.firstChild.src === selectCarte) {
              element.classList.add("inventoryOnClick");
            }
          });
        });

        break;
      case 2:
        let focus2 = document.querySelectorAll(".inventaireCartes");

        focus2.forEach((element) => {
          element.style.objectFit = "contain";
          element.style.minWidth = "100%";

          let focusAll = document.querySelectorAll(
            ".ongletInventaire__ItemContainer__displayItem__cardContainer__card"
          );

          focusAll.forEach((element) => {
            if (element.firstChild.src === selectAvatar) {
              element.classList.add("inventoryOnClick");
            }
          });
        });

        break;
      case 3:
        let focus3 = document.querySelectorAll(".inventaireCartes");

        focus3.forEach((element) => {
          element.style.objectFit = "contain";
          element.style.minWidth = "100%";

          let focusAll = document.querySelectorAll(
            ".ongletInventaire__ItemContainer__displayItem__cardContainer__card"
          );

          focusAll.forEach((element) => {
            if (element.firstChild.src === selectCadre) {
              element.classList.add("inventoryOnClick");
            }
          });
        });

        break;
      default:
        break;
    }
  }, [stuffOwned]);

  useEffect(() => {
    getOneUser();
  }, [loaded]);

  useEffect(() => {
    document.getElementById("images").style.border = "2px solid #FFC107";
  }, []);

  return (
    <div className="inventairePage">
      <ToastContainer
        position="bottom-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="dark"
      />

      <Navbar />
      <div className="ongletInventaire">
        <div className="ongletInventaire__ItemContainer">
          <div className="ongletInventaire__ItemContainer__top">
            <button id="bouttonSvg" onClick={applyChoice}>
              Sélectionner
            </button>
          </div>

          <div className="ongletInventaire__ItemContainer__displayItem">
            {stuffOwned.map((cartes) => (
              <div
                key={cartes.id}
                onClick={changeDisplay}
                className="ongletInventaire__ItemContainer__displayItem__cardContainer"
              >
                <div className="ongletInventaire__ItemContainer__displayItem__cardContainer__card">
                  <img
                    className="inventaireCartes"
                    id={cartes.id}
                    src={cartes.lien}
                    alt="images de la boutique"
                  />

                  <div className="ongletInventaire__ItemContainer__displayItem__cardContainer__card__info">
                    <FontAwesomeIcon icon={faCircleCheck} />
                    <div className="ongletInventaire__ItemContainer__displayItem__cardContainer__card__info__bot">
                      <div className="ongletInventaire__ItemContainer__displayItem__cardContainer__card__info__bot__left">
                        <h3>{cartes.nom}</h3>
                        <p>{cartes.rareté}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="ongletInventaire__filtres">
          <button
            id="images"
            className="ongletInventaire__filtres__images"
            onClick={filtres}
          >
            <h3>Cartes</h3>
          </button>
          <button
            id="avatars"
            className="ongletInventaire__filtres__avatars"
            onClick={filtres}
          >
            <h3>Avatars</h3>
          </button>
          <button
            id="cadres"
            className="ongletInventaire__filtres__cadres"
            onClick={filtres}
          >
            <h3>Cadres</h3>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Inventaire;
